import Menu from '../Menu/menu';

export default Menu;